var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 200,
    viewBox: "0 0 180 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V70H30V110H80V130H50V200H130V130H100V110H150V70H180V0H100V70H130V90H50V70H80V0H0ZM70 150H110V180H70V150ZM20 20H60V50H20V20ZM120 20H160V50H120V20Z",
    fill: "#169c50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttended);
export default __webpack_public_path__ + "static/media/Attended.b6a462982a7d048a35fc1330b4c40285.svg";
export { ForwardRef as ReactComponent };